import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "description"
}
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['nr-field', `field--type-${$props.type}`])
  }, [
    _createVNode(_component_NrFormLabel, {
      class: _normalizeClass($options.labelClassnames),
      for: $data.id
    }, _createSlots({
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString($props.label), 1)
        ])
      ]),
      _: 2
    }, [
      ($props.withTooltip)
        ? {
            name: "tip",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.iconTooltipText), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["class", "for"]),
    ($props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($props.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), _mergeProps(_ctx.$attrs, {
        class: $options.inputClassNames,
        id: $data.id,
        name: $props.name,
        required: $props.required,
        type: $props.type,
        maxlength: $props.maxLength,
        minLength: $props.minLength,
        rows: $props.tag === 'textarea' ? (_ctx.$attrs.rows ? _ctx.$attrs.rows : 4) : '',
        value: $props.modelValue
      }, _toHandlers($options.passthroughListeners), {
        onInput: $options.handleInput,
        onKeydown: $options.handleKeydown,
        onBlur: $options.handleBlur,
        checked: $props.type === 'checkbox' && !!this.modelValue
      }), null, 16, ["class", "id", "name", "required", "type", "maxlength", "minLength", "rows", "value", "onInput", "onKeydown", "onBlur", "checked"])),
      ($props.help)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(this.help), 1))
        : _createCommentVNode("", true),
      (Object.keys($data.errors || {}).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.errors, (value, key) => {
            return (_openBlock(), _createElementBlock("p", {
              key: key,
              class: "help is-danger"
            }, _toDisplayString(value), 1))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ], 2))
}